import { TGetMenuPayload } from "./types";

export namespace MenuApi {
  export async function getMenu(payload: TGetMenuPayload) {
    const server = "/api/authorization/getMenu";
    let headers = new Headers({
      Authorization: `Bearer ${payload.accessToken}`,
      "content-type": "application/json",
    });
    try {
      const response = await fetch(server, {
        method: "GET",
        headers: headers,
      });

      if (response.status !== 200) {
        const errorText = await response.text();
        throw new Error(errorText);
      }
      const data = await response.json();
      return data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
